import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import './TeamInfo.css';
import TeamSpecificNews from './TeamSpecificNews/TeamSpecificNews';
import Games from './Games/Games'

const TeamInfo = () => {
    const { teamId: teamIdParam, teamName } = useParams();
    const teamId = parseInt(teamIdParam, 10);
    const [rosterData, setRosterData] = useState(null);
    const [rosterLoading, setRosterLoading] = useState(false);
    const [rosterError, setRosterError] = useState(null);
    const [starredPlayers, setStarredPlayers] = useState({});
    const [teamInfo, setTeamInfo] = useState(null);
    const [teamInfoLoading, setTeamInfoLoading] = useState(false);
    const [teamInfoError, setTeamInfoError] = useState(null);
     const [starredTeams, setStarredTeams] = useState({}); 
    const navigate = useNavigate();
    const [message, setMessage] = useState(null); 
    useEffect(() => {
         const fetchTeamRoster = async () => {
            if (!teamId) return;
            setRosterLoading(true);
            setRosterError(null);
            setRosterData(null);
            try {
                const response = await fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/roster?season=2024`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const json = await response.json();
                setRosterData(json.roster);
            } catch (error) {
                setRosterError(error);
            } finally {
                setRosterLoading(false);
            }
        };
        const fetchTeamInfo = async () => {
            if (!teamId) return;
            setTeamInfoLoading(true);
            setTeamInfoError(null);
            setTeamInfo(null);
            try {
                const response = await fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const json = await response.json();
                setTeamInfo(json);
            } catch (error) {
                setTeamInfoError(error);
            } finally {
                setTeamInfoLoading(false);
            }
        };

       const fetchInitialStarredPlayers = async () => {
          const accessToken = localStorage.getItem('accessToken');
          if (accessToken) {
              try {
                  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/fetch-players`, {
                      headers: {
                          Authorization: `Bearer ${accessToken}`
                      }
                  });
                  if (response.status === 200 && response.data && response.data.playerIds) {
                    const initialStarred = response.data.playerIds.reduce((acc, playerId) => {
                         acc[playerId] = true;
                         return acc;
                    }, {});
                    setStarredPlayers(initialStarred);
                  } else {
                      console.log('Could not get users favorite players')
                  }
              } catch (error) {
                  console.error("There was an error getting the users favorite players:", error);
              }
          }
        };
        const fetchInitialStarredTeams = async () => {
            const accessToken = localStorage.getItem('accessToken');
            if (accessToken) {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/fetch-teams`, {
                        headers: {
                            Authorization: `Bearer ${accessToken}`
                        }
                    });
                    if (response.status === 200 && response.data && response.data.teamIds) {
                        const initialStarred = response.data.teamIds.reduce((acc, teamId) => {
                            acc[teamId] = true;
                            return acc;
                            }, {});
                        setStarredTeams(initialStarred);
                    } else {
                        console.log('Could not get users favorite teams')
                    }
                } catch (error) {
                    console.error("There was an error getting the users favorite teams:", error);
                }
            }
        };
        fetchTeamRoster();
        fetchTeamInfo();
        fetchInitialStarredPlayers();
        fetchInitialStarredTeams();
    }, [teamId]);

    const handlePlayerClick = (playerId, playerName) => {
        navigate(`/player/${playerId}/${playerName}`);  
    };

  const handleStarClickPlayer = (playerId) => {
      const accessToken = localStorage.getItem('accessToken');
        if(!accessToken) {
           setMessage("You must be logged in to favorite players!");
            setTimeout(() => setMessage(null), 3000);
        }
        else {
              setStarredPlayers((prevState) => {
                const isCurrentlyStarred = !!prevState[playerId];
                if (isCurrentlyStarred) {
                    handleRemovePlayerId(playerId);
                    setMessage('Player removed from favorites');
                    setTimeout(() => setMessage(null), 3000);
                  return {
                    ...prevState,
                    [playerId]: false,
                  };
                } else {
                    handleAddPlayerId(playerId);
                    setMessage('Player favorited successfully!');
                    setTimeout(() => setMessage(null), 3000);

                  return {
                    ...prevState,
                    [playerId]: true,
                  };
                }
              });
          }
      };
    const handleStarClickTeam = (teamId) => {
        const accessToken = localStorage.getItem('accessToken');
        if(!accessToken) {
            setMessage("You must be logged in to favorite teams!");
            setTimeout(() => setMessage(null), 3000); 
        } else {
            setStarredTeams((prevState) => {
                const isCurrentlyStarred = !!prevState[teamId];
                if (isCurrentlyStarred) {
                    handleRemoveTeamId(teamId);
                    setMessage('Team removed from favorites');
                    setTimeout(() => setMessage(null), 3000);
                    return {
                        ...prevState,
                        [teamId]: false,
                        };
                } else {
                handleAddTeamId(teamId);
                setMessage('Team favorited successfully!');
                setTimeout(() => setMessage(null), 3000);
                return {
                    ...prevState,
                    [teamId]: true,
                    };
                }
            });
        }
    };

    const handleAddPlayerId = async (playerId) => {
        try {
            const accessToken = localStorage.getItem('accessToken')
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/users`, {
                playerId: playerId
            }, {
                headers: {
                Authorization: `Bearer ${accessToken}`
            }
            });
            if (response.status === 200) {
                console.log("Player ID added successfully");
                    // After successfully adding the player to the backend, update sessionStorage
                try{
                    const playerResponse = await axios.get(`https://statsapi.mlb.com/api/v1/people/${playerId}`);
                    const playerName = playerResponse.data.people[0].fullName;
                    
                    const favoritesJSON = sessionStorage.getItem('favorites');
                    let favoritesArray = [];

                    if (favoritesJSON) {
                    favoritesArray = JSON.parse(favoritesJSON);
                    }

                    // Add name if it doesn't exist
                if(!favoritesArray.includes(playerName)){
                    favoritesArray.push(playerName);
                    sessionStorage.setItem('favorites', JSON.stringify(favoritesArray));
                    console.log("Player added successfully to favorites in session storage", playerName);
                    } else {
                        console.log('Player already exists in favorites', playerName);
                    }

                } catch(error){
                    console.error('Error adding name to favorites', error)
                }


            } else {
                console.log("There was an issue adding the Player ID")
            }
        } catch (error) {
            console.error("There was an error adding the player id:", error)
        }
    };
    const handleAddTeamId = async (teamId) => {
        try {
            const accessToken = localStorage.getItem('accessToken');
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/users/add-team`, {
                teamId: teamId
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
    
            if (response.status === 200) {
                console.log("Team ID added successfully");
    
                try {
                    // Fetch the team name from the MLB API
                    const teamResponse = await axios.get(`https://statsapi.mlb.com/api/v1/teams/${teamId}`);
                    const teamName = teamResponse.data.teams[0].name;


                    // Update sessionStorage with the new team name
                    const favoritesJSON = sessionStorage.getItem('favorites');
                    let favoritesArray = [];

                    if (favoritesJSON) {
                        favoritesArray = JSON.parse(favoritesJSON);
                    }

                        // Add name if it doesn't exist
                    if(!favoritesArray.includes(teamName)){
                            favoritesArray.push(teamName);
                            sessionStorage.setItem('favorites', JSON.stringify(favoritesArray));
                            console.log("Team added successfully to favorites in session storage", teamName);
                    } else {
                        console.log('Team already exists in favorites', teamName);
                    }
                }
                catch(error){
                    console.error('Error adding name to favorites', error)
                }
            } else {
                console.log("There was an issue adding the Team ID");
            }
        } catch (error) {
            console.error("There was an error adding the team id:", error);
        }
    };
    
    const handleRemovePlayerId = async (playerId) => {
        try {
            const accessToken = localStorage.getItem('accessToken');
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/users`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                data: {
                    playerId: playerId
                }
            });
    
            if (response.status === 200) {
                console.log("Player ID removed successfully");
    
                // After successfully removing the player from the backend, update sessionStorage
                try {
                    const playerResponse = await axios.get(`https://statsapi.mlb.com/api/v1/people/${playerId}`);
                    const playerName = playerResponse.data.people[0].fullName;

                    const favoritesJSON = sessionStorage.getItem('favorites');
                    if (favoritesJSON) {
                        const favoritesArray = JSON.parse(favoritesJSON);
                            const updatedFavorites = favoritesArray.filter(name => name !== playerName);
                        sessionStorage.setItem('favorites', JSON.stringify(updatedFavorites));
                        console.log(`Removed ${playerName} from favorites. Updated favorites:`, updatedFavorites);

                    } else {
                        console.log("No favorites found in session storage")
                    }
               
                } catch (error) {
                        console.error('Error removing player from favorites in session storage:', error);
                }
            } else {
                console.log("There was an issue removing the Player ID");
            }
        } catch (error) {
            console.error("There was an error removing the player id:", error);
        }
    };
    const handleRemoveTeamId = async (teamId) => {
        try {
            const accessToken = localStorage.getItem('accessToken');
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/users/remove-team`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                data: {
                    teamId: teamId
                }
            });

            if (response.status === 200) {
                console.log("Team ID removed successfully");

                try {
                        // Fetch the team name from the MLB API
                    const teamResponse = await axios.get(`https://statsapi.mlb.com/api/v1/teams/${teamId}`);
                    const teamName = teamResponse.data.teams[0].name;
                    // Update sessionStorage to remove the team name
                    const favoritesJSON = sessionStorage.getItem('favorites');
                    if (favoritesJSON) {
                    const favoritesArray = JSON.parse(favoritesJSON);
                        const updatedFavorites = favoritesArray.filter(name => name !== teamName);
                        sessionStorage.setItem('favorites', JSON.stringify(updatedFavorites));
                        console.log(`Removed ${teamName} from favorites. Updated favorites:`, updatedFavorites);

                    } else {
                    console.log('No favorites found in session storage');
                    }
                } catch (error) {
                        console.error('Error removing team from favorites in session storage:', error);
                }
            } else {
                console.log("There was an issue removing the Team ID");
            }
        } catch (error) {
            console.error("There was an error removing the team id:", error);
        }
    };

  if (!teamInfo || !teamInfo.teams || teamInfo.teams.length === 0) {
    return <div>Loading team information...</div>; 
  }

    return (
        <div className="background">
            {message && (
                <div className="message-popup">
                    {message}
                </div>
            )}
            <div className="background-team-title">
                <h3> {`${teamName}`} 
                    <span
                        onClick={() => handleStarClickTeam(teamId)}
                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                    >
                    {starredTeams[teamId] ? (
                        <StarIcon className="star-icon" />
                        ) : (
                        <StarBorderIcon className="star-icon" />
                        )}
                    </span>
                </h3>
            </div>
            <div className="background-team-container">
                <div className="background-teamlogo">
                    <img
                        src={`/Team-Logos/${teamId}.png`}
                        alt={`${teamName} Logo`}
                        className="team-logo"
                    />
                </div>
                <div className="background-teaminfo">
                    {teamInfoLoading && <p>Loading team info...</p>}
                    {teamInfoError && (
                        <p className="error">Error loading team info: {teamInfoError.message}</p>
                    )}
                    {teamInfo && (
                        <>
                            <p><strong>Location:</strong> {teamInfo.teams[0].locationName}</p>
                            <p><strong>First Year:</strong> {teamInfo.teams[0].firstYearOfPlay}</p>
                            <p><strong>League:</strong> {teamInfo.teams[0].league.name}</p>
                            <p><strong>Division:</strong> {teamInfo.teams[0].division.name}</p>
                            <p><strong>Venue:</strong> {teamInfo.teams[0].venue.name}</p>
                        </>
                    )}
                </div>
            </div>
            {rosterLoading && <p>Loading roster...</p>}
            {rosterError && <p className="error">Error loading roster: {rosterError.message}</p>}

            {rosterData && (
                <ul className="background-container-players">
                    {rosterData.map((player) => (
                        <li
                        key={player.person.id}
                        className="player-item"
                        onClick={() => handlePlayerClick(player.person.id, player.person.fullName)}
                        >
                        <span>
                            {player.person.fullName} - {player.position.name}
                        </span>
                        <span
                            className="star-icon"
                            onClick={(e) => {
                            e.stopPropagation();
                            handleStarClickPlayer(player.person.id);
                            }}
                        >
                            {starredPlayers[player.person.id] ? (
                            <StarIcon className="star-icon" />
                            ) : (
                            <StarBorderIcon className="star-icon" />
                            )}
                        </span>
                        </li>
                    ))}
                </ul>
            )}
            <div className="background-recent-games">
                <h3 className="sub-title"> Previous Games</h3>
                <Games firstYearOfPlay={teamInfo.teams[0].firstYearOfPlay}/>
            </div>
            <div className="background-team-news">
                <h3 className="sub-title"> Team News</h3>
                <TeamSpecificNews/>
            </div>
        </div>
    );
};

export default TeamInfo;